import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS, RTL_LANGS, LANGUAGES } from "../lib/i18n";
import { APP_TRANSLATIONS } from "../lib/i18n_app";
import PAGES_TRANSLATIONS from "../lib/pages_i18n.json";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

const SUPPORTED = LANGUAGES.map((l) => l.code);

function detectBrowserLang() {
  const stored = localStorage.getItem("aca_lang");
  if (stored && SUPPORTED.includes(stored)) return stored;
  const candidates = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language || "fr"];
  for (const c of candidates) {
    const code = String(c).toLowerCase().split("-")[0];
    if (SUPPORTED.includes(code)) return code;
  }
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectBrowserLang);

  useEffect(() => {
    if (!localStorage.getItem("aca_lang")) localStorage.setItem("aca_lang", lang);
    const rtl = RTL_LANGS.includes(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? "rtl" : "ltr";
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("aca_lang", l);
    setLangState(l);
  };

  const t = (key) => {
    const dict = { ...(TRANSLATIONS.fr || {}), ...(APP_TRANSLATIONS.fr || {}), ...(PAGES_TRANSLATIONS.fr || {}),
      ...(TRANSLATIONS[lang] || {}), ...(APP_TRANSLATIONS[lang] || {}), ...(PAGES_TRANSLATIONS[lang] || {}) };
    return dict[key] ?? key;
  };

  // Traducteur forcé en français (utilisé par l'espace admin, mono-langue FR)
  const tf = (key) => {
    const dict = { ...(TRANSLATIONS.fr || {}), ...(APP_TRANSLATIONS.fr || {}), ...(PAGES_TRANSLATIONS.fr || {}) };
    return dict[key] ?? key;
  };

  const isRTL = RTL_LANGS.includes(lang);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tf, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}
